import React from 'react'
import ShowScientificDay from '../components/ScientificDay/ShowScientificDay'
import { useTranslation } from 'react-i18next'

const ScientificDay = () => {
  const { t } = useTranslation()

  return (
    <div className='mt-20'>
      <h1 className='text-center text-3xl'>{t("Journée scientifique")}</h1>
      <ShowScientificDay />
    </div>
  )
}

export default ScientificDay